export default [
  {
    header: 'Игры',
  },
  {
    title: 'Список игр',
    route: 'games',
    icon: 'CastIcon',
    tagVariant: 'light-warning',
  },
  {
    title: 'Создать игру',
    route: 'random-game-create',
    icon: 'CastIcon',
    tagVariant: 'light-warning',
  },
  {
    title: 'Импорт расписания',
    route: 'schedule-import',
    icon: 'CalendarIcon',
    tagVariant: 'light-warning',
  },
]
